module.exports = __webpack_public_path__ + "img/icon_03.e1a39ce6.gif";